/**
 * External Dependencies
 */

// window.jQuery = window.$ = require('jquery');
import _throttle from 'lodash.throttle';
import GLightbox from 'glightbox';

const lightbox = GLightbox({
  selector: `.wp-block-image a`,
  openEffect: 'fade',
  closeEffect: 'fade',
})

document.documentElement.style.setProperty('--header-height', `${document.querySelector('.c-header').getBoundingClientRect().height}px`)
let docHeight = window.innerHeight

const setCustomVariables = () => {
  docHeight = window.innerHeight
  document.documentElement.style.setProperty('--doc-height', `${docHeight}px`)
}

setCustomVariables()

window.addEventListener('resize', _throttle(() => {
  setCustomVariables()
}, 100))

window.addEventListener('scroll', () => {
  document.documentElement.style.setProperty('--header-height', `${document.querySelector('.c-header').getBoundingClientRect().height}px`)
})
/**
 * Modules
 */

import './modules/clipboard'
import './modules/trigger';
import './modules/slider';
import './modules/logo-anim';
import './modules/lazyImages';
import './modules/wpcomment';
import './modules/search';
import './modules/facet';
import './modules/media';
import './modules/articleAside';
import './modules/hero';
import './modules/sharer';
import './modules/dropdownMenu';
